import {Button, Divider} from "@blueprintjs/core";
import styled from "@emotion/styled";
import {COLORS} from "../../../../constants/constants";

const heightOfHeader = 69;
const heightOfFooter = 71;

export const Container = styled.div`
  font-family: Roboto;
  height: 100%;
  width: calc(100vw - 220px);

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const Header = styled.div`
  width: 100%;
  height: ${heightOfHeader}px;
  padding: 20px 25px;

  display: flex;
  justify-content: flex-start;
  align-items: center;

  box-shadow: 0px 1px 6px 0px #0000001a;
`;
export const HeaderText = styled.h2`
  font-size: 24px;
  font-weight: 400;
`;

export const Body = styled.div`
  height: calc(100vh - ${heightOfHeader + heightOfFooter}px);
  width: 60%;
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 25px 40px 25px 25px;
  overflow: auto;
`;

export const Footer = styled.div`
  width: 100%;
  height: ${heightOfFooter}px;
  padding: 20px 25px;

  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 80px;

  box-shadow: 0px 7px 20px 0px #00000059;
`;

export const CancelButton = styled(Button)`
  margin: 0;

  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 0px;

  cursor: pointer;
  color: ${COLORS.DARK_BLUE} !important;

  border: none !important;
  &:hover {
    background: none !important;
  }

  &[disabled] {
    color: rgba(119, 119, 119, 0.3) !important;
  }
`;

export const SaveButton = styled(Button)`
  width: 63px;

  color: white !important;

  border-radius: 4px;
  background: linear-gradient(180deg, #214a89 0%, #14305a 100%);
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.25);

  &[disabled] {
    border: 1px solid #d9d9d9;
    background: rgba(15, 18, 23, 0.1) !important;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05) !important;
  }
`;

export const Input = styled.input`
  border: 1px solid #c3c3c3;
  border-radius: 4px;
  box-shadow: none;
  font-size: 14px;
  width: 70px;
  height: 32px;
  padding: 6px 15px 6px 15px;
  border-radius: 4px;
  text-align: center;
  margin-right: 13px;
`;

export const UnitText = styled.span`
  font-size: 14px;
  font-weight: 400;
`;

export const SectionTitle = styled.h3`
  margin: 0px 0px 12px 0px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1px;
  color: ${COLORS.TEXT_GRAY};

  text-transform: uppercase;
`;

export const CustomDivider = styled(Divider)`
  width: 100%;
  margin: 0px;
`;

export const ContentContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
`;

export const ContentTop = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 24px 0px 8px;
`;

export const ContentBottom = styled.div`
  width: 100%;
`;

export const ContentTitle = styled.h4`
  margin: 0;
  font-size: 16px;
  font-weight: 400;

  color: ${COLORS.TEXT_BLACK};
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

export const SingleSelectButton = styled(Button)`
  min-width: 70px;
  border: 1px solid #c3c3c3;
  border-radius: 4px;
`;

export const SingleSelectItem = styled.li<{isSelected?: boolean}>`
  font-family: Roboto;
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.isSelected ? "#0038FF1A" : "transparent")};
  border-radius: 4px;
  margin: 2px 0px;
  padding: 6px;
  cursor: pointer;

  :hover {
    background: #0038ff1a;
  }

  .bp5-menu-item-selected-icon {
    display: none;
  }
`;
